import React, {useEffect, useState} from "react";
import {useIntl} from 'react-intl';
import {useSelector} from 'react-redux';
import { useRealtimeUnits } from 'Core/hooks';

// Components
import {Form, ToggleSwitch} from 'Components';
import Slider from '../../../../../../../../components/Slider';


export const FuelLevel = (props) => {

    const { value, triggers, triggersRaw, onChange, formRef } = props
    const { messages } = useIntl()
    const units = useRealtimeUnits({ trackFields: ['id', 'name', 'label', 'disabled', 'driverId', 'vehicleStatusId', 'tags'] });
    const [dropping, setDropping] = useState(0)
    const [raising, setRaising] = useState(0)

    useEffect(() => {
        if (value?.dropping == undefined)
            onChange({
                ...value,
                dropping: 10,
                raising: 0,
            }, [])
        else {
            setDropping(value.dropping)
            setRaising(value.raising)
        }
    }, [value]);


    const isValidRequiredItems = (clickNext = false) => {
        let isValid = false
        if (dropping > 0 || raising > 0) {
            isValid = true
        }      

        if (value.trigger && clickNext) {
            isValid = triggersRaw?.length > 0
        }
        return isValid
    }

    return (
        <Form ref={formRef}
            onSubmit={() => {
                if (isValidRequiredItems(true)) {

                    onChange({ ...value,
                        dropping: dropping,
                        raising: raising,
                    }, triggersRaw)
                    return true
                }

                return false
            }}
        >
            {
                //value.dropping != undefined &&
                <div className="form-item">
                    <label className="input-normal-label">{messages['alertsNewAlert_triggersLabel']}</label>
                    {
                        (!isValidRequiredItems()) &&
                        <div className="text-danger">
                            {messages["alertsNewAlert_triggerValidation"]}
                        </div>
                    }

                    <div style={{ paddingTop: "20px", width: "100%" }}>
                        <ToggleSwitch
                            id="dropping"
                            small
                            blueToggle
                            optionLabels={["", ""]}
                            label={messages['alertsNewAlert_FuelLevelReduce']}
                            checked={(dropping > 0) ? true : false}
                            onChange={(event) => {
                                setDropping(event ? 10 : 0)
                            }}

                        />
                        {
                            dropping > 0 &&
                            <div style={{ width: "100%" }}>
                                <Slider
                                    min={10}
                                    max={100}
                                    sliderOneColor={false}
                                    showValue
                                    //measure={odometerMeasure}
                                    valueLabelDisplay={'off'}
                                    value={Number(dropping)}
                                    onChange={(event) => setDropping(event)}
                                />
                            </div>
                        }
                    </div>

                    <div style={{ paddingTop: "20px", width: "100%" }}>
                        <ToggleSwitch
                            id="raising"
                            small
                            blueToggle
                            optionLabels={["", ""]}
                            label={messages['alertsNewAlert_FuelLevelIncrease']}
                            checked={(raising > 0) ? true : false}
                            onChange={(event) => {
                                setRaising(event ? 10 : 0)
                            }}
                        />

                        {
                            raising > 0 &&
                            <div style={{ width: "100%" }}>
                                <Slider
                                    min={10}
                                    max={100}
                                    sliderOneColor={false}
                                    showValue
                                    //measure={odometerMeasure}
                                    valueLabelDisplay={'off'}
                                    value={Number(raising)}
                                    onChange={(event) => setRaising(event)}
                                />
                            </div>
                        }
                    </div>
                </div>
            }
        </Form>
    );
}
